export default __webpack_public_path__ + "static/media/full-bundle-accuchek-gray@3x.d7e562c8.jpg";